import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import { format,parse } from 'date-fns';
import { takeWhile } from "rxjs/operators";


import {
    FvmsCommonService
    ,FvmsApiDtgUserService
    ,FvmsApiAuthService
    ,FvmsApiDtgTeamService
} from "src/app/shared/service";
import {
    DtgActionType
    ,PagingInfo
} from "src/app/shared/vo";
import {DtgManageCarSearchComponent} from '../../../car';
import {DtgManageDriverSearchComponent} from '../../../driver';
import * as FileSaver from 'file-saver';

@Component({
    templateUrl: './dtg.manage.schedule.drive.regist.component.html'
    ,providers: []
})
export class DtgManageScheduleDriveRegistComponent implements OnInit,OnDestroy,AfterViewInit {

    isContinue:boolean = true;
    currentUserInfo:any;
    @Input() companyId:string;
    @Input() userCarRunId:number;
    @Input() userId:string;
    @Input() dtgUnitId:string;
    @Input() dtgActionType:DtgActionType;
    filePath:string = null;
    selectedFile:any = null;
    formGroup: FormGroup;
    checkRegDt:boolean = false;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiDtgUserService:FvmsApiDtgUserService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
    }

    get f() { return this.formGroup.controls; }

    ngOnInit(): void {

        this.initForm();
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                // this.checkSameId = true;
                // this.formGroup.disable();
                break;
        }
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        this.isContinue = false;
    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            userCarRunId:null
            ,userId:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,userNm:[
                ""
                ,[
                  Validators.required
                ]
            ]
            ,dtgUnitId:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,dtgCarNo:[
                ""
                ,[
                  Validators.required
                ]
            ]
            ,dtgRegDtFrom:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,dtgRegDtTo:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,dtgRegDtYy:null
            ,dtgRegDtMm:null
            ,dtgRegDtDd:null
            ,dtgRegDtHh:null
            // ,dtgRegDtFromDate:[
            //     ""
            //     ,[
            //         Validators.required
            //     ]
            // ]
            // ,dtgRegDtToDate:[
            //     ""
            //     ,[
            //         Validators.required
            //     ]
            // ]
            // ,dtgRegDtFromTime:[
            //     ""
            //     ,[
            //         Validators.required
            //     ]
            // ]
            // ,dtgRegDtToTime:[
            //     ""
            //     ,[
            //         Validators.required
            //     ]
            // ]
            ,drivePathNm:null
            ,drivePathFromNm:null
            ,drivePathToNm:null
            ,useYn:"Y"
        });
    }

    // excel file load
    loadUserCarRunFromExcel(e) {
        if (!e.target.files || e.target.files.length<=0) {
            // console.log("No file selected!");
            alert("파일을 선택해주세요.");
            return;
        } else if (e.target.files.length>1) {
            // console.log("please select one file!");
            alert("하나의 파일만 선택할 수 있습니다.");
            return;
        }

        // let file:File = e.target.files[0];
        this.selectedFile = e.target.files[0];
        this.filePath = e.target.files[0].name;
    }

    uploadExcelFile(file: File) {
        // let testFile = new File('./testFile');
        let baseInfo = {
          companyId: this.companyId
          , userId: this.userId
        }

        this.fvmsCommonService.setIsLoading(true);
        let result = this.fvmsApiDtgUserService.upsertUserCarRunFile(baseInfo, file)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe((apiResponse: Blob) => {
                // let fileSaver = new FileSaver();
                if (apiResponse.type === "application/json") {
                    alert("배차정보 등록을 완료 하였습니다.");
                } else {
                    FileSaver.saveAs(apiResponse, 'user_car_run_result.xls');
                }
                this.fvmsCommonService.setIsLoading(false);
                this.clickOk();
            },
            (ex) => {
                console.error("DtgManageScheduleDriveRegistComponent","uploadExcelFile",ex);
                alert('배차정보 일괄등록 작업중 오류가 발생하였습니다.');
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    // 일정 및 입력 날짜 검증
    checkDtgUserCarRun() {
        // 입력 값 검증
        if (this.f.dtgRegDtFrom.value > this.f.dtgRegDtTo.value) {
            this.checkRegDt = false;
            return;
        }
        // promise 생성
        let promise = new Promise((resolve,reject) => {
            let searchInfo = {
                companyId:this.companyId
                ,userCarRunId:this.f.userCarRunId.value
                ,dtgUnitId:this.f.dtgUnitId.value
                ,dtgRegDtFrom:this.f.dtgRegDtFrom.value
                ,dtgRegDtTo:this.f.dtgRegDtTo.value
            };

            this.fvmsApiDtgUserService.checkDtgUserCarRun(searchInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(apiResponse => {
                    if(apiResponse.resultStatus === "ok"){
                        let result = (apiResponse.resultValue === 0);
                        if(result){
                            this.checkRegDt = result;
                            resolve(result);
                        } else {
                            this.checkRegDt = false;
                            resolve(false);
                        }
                    }else{
                        this.checkRegDt = false;
                        resolve(false);
                    }
                });

        });

        return promise;
    }

    clickOk() {
        this.activeModal.close({
            "result":"ok"
        });
    }

    clickCancel() {
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSave() {
        // this.selectedFile = e.target.files[0];
        if (!this.selectedFile) {
            // console.log("No file selected!");
            alert("파일을 선택해주세요.");
            return;
        }

        // this.loadExcelFile();
        this.uploadExcelFile(this.selectedFile);
    }


    onSubmit(){

        this.submitted = true;
        let userCarRunInfo = {
            userCarRunId:this.f.userCarRunId.value
            ,userId:this.f.userId.value
            ,userNm:this.f.userNm.value
            ,dtgUnitId:this.f.dtgUnitId.value
            ,dtgCarNo:this.f.dtgCarNo.value
            ,dtgRegDtFrom:this.f.dtgRegDtFrom.value.replace("T", " ")
            ,dtgRegDtYy:this.f.dtgRegDtYy.value
            ,dtgRegDtMm:this.f.dtgRegDtMm.value
            ,dtgRegDtDd:this.f.dtgRegDtDd.value
            ,dtgRegDtHh:this.f.dtgRegDtHh.value
            ,dtgRegDtTo:this.f.dtgRegDtTo.value.replace("T", " ")
            // ,dtgRegDtFromDate:this.f.dtgRegDtFromDate.value
            // ,dtgRegDtToDate:this.f.dtgRegDtToDate.value
            // ,dtgRegDtFromTime:this.f.dtgRegDtFromTime.value
            // ,dtgRegDtToTime:this.f.dtgRegDtToTime.value
            ,drivePathNm:this.f.drivePathNm.value
            ,drivePathFromNm:this.f.drivePathFromNm.value
            ,drivePathToNm:this.f.drivePathToNm.value
            ,createUser:this.currentUserInfo.userId
            ,updateUser:this.currentUserInfo.userId
            ,useYn:this.f.useYn.value
        }
        // valid availability
        this.checkDtgUserCarRun().then((item:any)=>{
            let checkResult = item;
            // valid form data
            if (this.formGroup.invalid || checkResult === false) {
                return;
            }
        });
        return;
    }
}
